import { Button } from 'components/button/Button';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from 'reducers/modal';
import { setConfirmApplicationWithdraw } from 'reducers/withdrawAppScoresModal';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n/i18n';

type WithdrawAppFromResendScoresModalProps = {
  data: {
    title: string;
    modalClasses: string;
    modalHeaderClasses: string;
    projectId: number;
    redirectURL: any;
    applicationReference: any;
  };
};

const WithdrawAppFromResendScoresModal: React.FC<WithdrawAppFromResendScoresModalProps> = ({
  data,
}) => {
  const { t } = useTranslation('Withdraw+Application+Modal', { i18n });

  const dispatch = useDispatch();

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleSubmit = async () => {
    dispatch(setConfirmApplicationWithdraw(true));
    dispatch(closeModal());
  };

  return (
    <div className="WithdrawApplicationModal FullWidth">
      <div className="Content">
        <p>{t('SSCandidate_Withdraw_Application_Modal_Withdraw_Desc_1')} <strong>{t('SSCandidate_Withdraw_Application_Modal_Cancel')}</strong> {t('SSCandidate_Withdraw_Application_Modal_Withdraw_Desc_2')} <strong>{t('SSCandidate_Withdraw_Application_Modal_Withdraw_Exit')}</strong> {t('SSCandidate_Withdraw_Application_Modal_Withdraw_Desc_3')}</p>
      </div>
      <div className="ModalFooter">
        <Button priority="tertiary" type="button" onClick={handleCloseModal}>
          {t('SSCandidate_Withdraw_Application_Modal_Cancel')}
        </Button>
        <Button
          className="Discard"
          priority="primary"
          type="submit"
          onClick={handleSubmit}
        >
          {t('SSCandidate_Withdraw_Application_Modal_Withdraw_Exit')}
        </Button>        
      </div>
    </div>
  );
};

export { WithdrawAppFromResendScoresModal };
